export const dataInitialWord = () => {
    return {
        suggestedWordOfCaution: [],
        customWordOfCaution: []
    }
}

export default {
    wordOfCautionSga: dataInitialWord()
};
